import { maskZipCode } from './masks';
import { normalizeAddressName } from './addressName';

/**
 * Converte endereço de GET .../dados-basicos para o formato do AddressForm / useAddress.
 * @param {Object|null|undefined} addr
 * @returns {Object}
 */
export function mapBasicLegalPersonAddressToForm(addr) {
    if (!addr || typeof addr !== 'object') {
        return {};
    }
    const state = addr.state || {};
    const abbr = state.abbreviation ?? state.abbr ?? state.code ?? '';
    const zipDigits = String(addr.zipCode ?? '').replace(/\D/g, '');
    return {
        name: addr.name || '',
        zipCode: zipDigits.length ? maskZipCode(zipDigits) : '',
        street: addr.street || '',
        number: addr.number != null && addr.number !== '' ? String(addr.number) : '',
        complement: addr.complement || '',
        district: addr.district || '',
        city: addr.city || '',
        stateAbbr: typeof abbr === 'string' ? abbr : String(abbr || ''),
        stateName: state.name || '',
        // Não reutilizar id de sistemas externos no POST de cadastro
        addressId: null,
    };
}

/**
 * Monta AddressDTO para CreateLegalPersonRequest (mesmo formato usado em colaboradores).
 * @param {Object} addr - Estado vindo do AddressForm / useAddress
 * @returns {Object}
 */
export function buildAddressDtoFromForm(addr) {
    return {
        id: addr?.addressId ?? null,
        name: normalizeAddressName(addr?.name),
        street: (addr?.street || '').trim(),
        number: (addr?.number || '').trim(),
        complement: (addr?.complement || '').trim(),
        district: (addr?.district || '').trim(),
        city: (addr?.city || '').trim(),
        zipCode: (addr?.zipCode || '').trim(),
        state: {
            abbreviation: (addr?.stateAbbr || '').trim(),
            name: (addr?.stateName || addr?.stateAbbr || '').trim(),
        },
    };
}
